module.exports = __webpack_public_path__ + "static/media/replay_box_active.6f1345a0.svg";